import { Layout, Typography } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Logo from 'src/assets/images/OMSLogoBlk.png'
import {
  resetEmailAddress,
  submitCodeAndPassword,
} from 'src/features/AuthSlice'
import {
  AuthBackdrop,
  AuthHeading,
  AuthLogo,
  AuthPageLayout,
  AuthSubheading,
  AuthSurface,
  AuthTrustText,
} from 'src/screens/login/authStyles'
import ResetPasswordForm from 'src/screens/reset-password/ResetPasswordForm'

const ResetPassword = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth)
  return (
    <AuthPageLayout className='layout'>
      <AuthBackdrop />
      <Layout.Content>
        <AuthSurface>
          <AuthLogo src={Logo} alt='Orders Made Simple logo' />
          <AuthHeading level={2}>Reset your password</AuthHeading>
          <AuthSubheading>
            Enter your email to receive a reset code, then create a secure new
            password.
          </AuthSubheading>
          <ResetPasswordForm
            submitEmailAddress={address => {
              dispatch(resetEmailAddress(address))
            }}
            user={user}
            submitCodeAndPassword={data => {
              dispatch(submitCodeAndPassword(data))
            }}
          />
          {user.error && (
            <Typography.Text type='danger'>{user.error}</Typography.Text>
          )}
          <AuthTrustText>
            Password recovery is protected by enterprise-grade authentication
          </AuthTrustText>
        </AuthSurface>
      </Layout.Content>
    </AuthPageLayout>
  )
}

export default ResetPassword
